
    <div class="play-wrapper" *ngIf="videoelement.play_method === 'onclickplay'">
        <a class="button button-white  button-large" 
        [ngClass]="{'d-none':videoActive}" 
        (click)="activeVideo()" 
        >Play</a>
    </div>


<div class="video-container w-100 h-100 position-absolute index-extralarge video-player-disable" 
[ngClass]="{'video-player-active':videoActive}" 
(mousemove)="onMouseMove($event)" #videoplayer>
    <div class="video-player" id="video-item-{{i}}"  [ngClass]="{ 'video-small': size == '2' || size == '1',
                                                                  'video-large': size == '4' || size == '8'}">
     <iframe
        width="1425" height="559"
        loading="lazy"
        class="e2e-iframe-trusted-src index-negative" 
        *ngIf="videourl" 
        [src]="videourl"
        frameborder=0   
        allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="autoplay">
    </iframe>
        <div *ngIf="videourl && videoelement.play_method === 'onclickplay'" class="video-button-controller" >     
            <a class="button button-white button-large" (click)="play()" *ngIf="player" 
            [ngClass]="{'d-none':player.clickPause, 'hide-button': hideButton}">Play</a>

            <a class="button button-white  button-large"  (click)="pause()"  *ngIf="player" 
            [ngClass]="{'d-none':player.clickPlay, 'hide-button': hideButton}">Pause</a>
            <a class="button button-white  button-large"  (click)="replay()" *ngIf="player"
             [ngClass]="{'d-none':player.clickReplay, 'hide-button': hideButton}">Replay</a> 
        </div> 
        <div *ngIf="videourl && videoelement.play_method === 'onclickplay'" class="bottom-video-item" >
            <div class="timer-counter" *ngIf="player" [ngClass]="{'show-duration':durationTimer}">
                <div class="float-left d-flex f-white" 
                            *ngIf="player.minuteprogress">{{player.minuteprogress}} : {{player.secondprogress}} </div> 
                            <div class="float-left d-flex space-side-3  f-white" 
                                        *ngIf="player.minuteprogress">/</div>
                <div class="d-flex  f-white" 
                *ngIf="player.totalminuteduration">{{player.totalminuteduration}} : {{player.totalsecondduration}} </div>
            </div>
            <div  class="seek-bar" *ngIf="player">
              <div class="slider" (click)="seekOutside($event)">
                <div class="slider-item"  [ngStyle]="{'width': player.seekbarproggress +'%'}"></div>
              </div>
            </div>
          </div>
     </div>
  </div>
  <div class="view-port-detect"
    inViewport
    [inViewportOptions]="{ threshold: [0] }"
    (inViewportAction)="onIntersection($event)">
 </div>